import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=d30f4eaa&"
import script from "./Footer.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Footer.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./Footer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports